import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {
  BrowserRouter as Router
} from "react-router-dom";
import App from './App';
import { PermissionsProvider } from './Utility/PermissionContext';
const rootElement = document.getElementById("root");
ReactDOM.render(
  <Router>
    <PermissionsProvider>
      <App />
    </PermissionsProvider>
  </Router>,
  rootElement
);
